import { BaseService } from './base';
import { ServiceCategory } from '../models/serviceCategory';

import { ApiRequest } from '../lib/request';
import { ApiResponse } from '../lib/response';

export class ServiceCategoryService extends BaseService<ServiceCategory> {
  override model = ServiceCategory;
  override modelName = 'serviceCategory';
  override modelLabel = 'Service Category';

  async addPhoto(
    serviceCategory: ServiceCategory,
    image: File,
    onUploadProgress?: (progressEvent: import('axios').AxiosProgressEvent) => void,
  ): Promise<ApiResponse<ServiceCategory>> {
    const formData = new FormData();
    formData.append('image', image);

    const request = new ApiRequest({
      method: 'POST',
      url: `${this.modelBaseUrl}/${serviceCategory.objectID()}/addPhoto`,
      data: formData,
      onUploadProgress,
    });

    return await this.requestItem<ServiceCategory>(request, this.model);
  }

  async deletePhoto(serviceCategory: ServiceCategory): Promise<ApiResponse<ServiceCategory>> {
    const request = new ApiRequest({
      method: 'POST',
      url: `${this.modelBaseUrl}/${serviceCategory.objectID()}/deletePhoto`,
      data: {},
    });

    return await this.requestItem<ServiceCategory>(request, this.model);
  }

  override async reorder(categories: ServiceCategory[]): Promise<ApiResponse<any>> {
    const data = categories.map((category) => ({
      id: category.objectID(),
    }));

    const request = new ApiRequest({
      method: 'POST',
      url: `${this.modelBaseUrl}/reorder`,
      data,
    });

    return await this.request(request);
  }
}
